import React from "react";
import Barcode from "react-barcode";
import { QRCode } from "react-qrcode-logo";
import "./index.scss";

const Tag = ({ codeValue, price, name, currency, hidePrice, hideName, barcodeType }) => (
  <div
    style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
  >
    {!hideName && (
      <h5 style={{ marginBottom: -3, fontSize: 11, fontWeight: 900 }}>{name}</h5>
    )}
    {!hidePrice && (
      <h4 style={{ marginBottom: -3, fontSize: 11, fontWeight: 900 }}>
        {currency}
        {price}
      </h4>
    )}
    {barcodeType === "2D" ? (
      <QRCode
        value={codeValue}
        size={100}
        style={{ marginTop: 5 }}
      />
    ) : (
      <Barcode
        value={codeValue}
        height={38}
        fontSize={10}
        width={0.9}
        marginTop={-7}
        marginLeft={26}
        format="CODE39"
      />
    )}
  </div>
);

class ProductsBarCode extends React.Component {
  render() {
    const { products, user, hidePrice, hideName, barcodeType, barcodeSource } = this.props;
    const currency = user
      ? user.currency
        ? user.currency
        : user.employer.currency
        ? user.employer.currency
        : ""
      : "";

    const resolveCode = (product) => {
      if (barcodeSource === "product_sku") {
        return product.product_sku || product.sku || "";
      }
      return product.sku || product.product_sku || "";
    };

    let barCodes = null;

    if (Array.isArray(products)) {
      barCodes = products.map((product, key) => {
        const codeValue = resolveCode(product);
        return codeValue ? (
          <Tag
            key={key}
            {...product}
            codeValue={codeValue}
            currency={currency}
            hidePrice={hidePrice}
            hideName={hideName}
            barcodeType={barcodeType}
          />
        ) : null;
      });
    } else if (products) {
      const codeValue = resolveCode(products);
      barCodes = codeValue ? (
        <Tag
          {...products}
          codeValue={codeValue}
          currency={currency}
          hidePrice={hidePrice}
          hideName={hideName}
          barcodeType={barcodeType}
        />
      ) : null;
    }

    return <div id="products-barcode">{barCodes}</div>;
  }
}

ProductsBarCode.defaultProps = {
  products: [],
  hidePrice: false,
  hideName: false,
  barcodeType: "1D",
  barcodeSource: "default",
};

export default ProductsBarCode;
